/******/
(() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsInspirationPage = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsInspirationPage = $.extend(this, window.PXUTheme.getSectionData($section));
    if ($( window ).width() <= 768) {
      if ($('.read-more-text > .shg-rich-text').height() >= 300) {
        $('.read-more-text').addClass('readmore readmore-closed');
        window.PXUTheme.jsInspirationPage.addReadmoreBtn($('.read-more-text'));
      }
    }
    if ($('.masonry_gallery')) {
      window.addEventListener('load', window.PXUTheme.jsInspirationPage.replaceLazyload());
    }
  },
  addReadmoreBtn: function($textDiv) {
    $textDiv.find('.shg-rich-text').after('<span class="readmore-btn">Read More</span>');
    $textDiv.on('click', '.readmore-btn', function() {
      if ($textDiv.hasClass("readmore-closed")) {
        $textDiv.find('.readmore-btn').html('Read Less');
        $textDiv.removeClass('readmore-closed');
      } else {
        $textDiv.find('.readmore-btn').html('Read More');
        $textDiv.addClass('readmore-closed');
      }
    });
  },
  runMasonry: function() {
    // Run Masonry function in utilities.js
    window.PXUTheme.applyMasonry('.grid-item', 5, '.masonry_gallery > .shg-box-content', '.grid__sizer');
  },
  replaceLazyload: function() {
    console.log('run replaceLazyload');
    var images = document.getElementsByClassName('shogun-image');
    if (images && images.length) {
      console.log('images && images.length = TRUE');
      for (var i = 0; i < images.length;i++) {
        var img = images[i];
        var src = img.getAttribute('src');
        var dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
          if (!src) {
            console.log('!src');
            img.setAttribute('src', dataSrc);
            img.classList.remove("shogun-lazyload");
            img.classList.remove("shogun-lazyloading");
            img.classList.add("lazyload");
          }
        }
      }
    }
    window.PXUTheme.jsInspirationPage.runMasonry();
  },
  unload: function($section) {
  }
}

/******/ })()
;